export default "__VITE_ASSET__C1b4JvofMUBPgDMj366g$Q__"